import { all, call, put, takeEvery } from "redux-saga/effects";
import {
  fetchFullCalendar,
  addNewCalendarEvent,
  deleteEvent,
  updateEvent,
} from "../../networking/calendar/networking";
import * as types from "../types/calendar";

function* fetchCalendarDetails(action) {
  try {
    if (action.payload) {
      const events = yield call(fetchFullCalendar, action.payload);
      if (events.error === null) {
        yield put({ type: types.SET_CALENDAR_CONTENT, events: events.payload });
      } else {
        throw new Error("Kunne ikke hente hendelser.");
      }
    } else {
      throw new Error("Kunne ikke hente kalender.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_CALENDAR_CONTENT, message: e });
  }
}

function* performAddCalendarEvent(action) {
  try {
    if (action.details) {
      var response = yield call(addNewCalendarEvent, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_ADD_CALENDAR_EVENT });
        yield put({
          type: types.CHANGE_CALENDAR_MODALS,
          modal: { addModal: false },
        });
      } else {
        throw new Error("Kunne ikke legge til hendelse.");
      }
    } else {
      throw new Error("Kunne ikke legge til i kalender.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_ADD_CALENDAR_EVENT, message: e });
    yield put({
      type: types.CHANGE_CALENDAR_MODALS,
      modal: { addModal: false },
    });
  }
}

function* performRemoveCalendarEvent(action) {
  try {
    if (action.details) {
      var response = yield call(deleteEvent, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_DELETE_CALENDAR_EVENT });
        yield put({
          type: types.CHANGE_CALENDAR_MODALS,
          modal: { editModal: false },
        });
      } else {
        throw new Error("Kunne ikke fjerne hendelse.");
      }
    } else {
      throw new Error("Kunne ikke slette hendelse.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_DELETE_CALENDAR_EVENT, message: e });
    yield put({
      type: types.CHANGE_CALENDAR_MODALS,
      modal: { editModal: false },
    });
  }
}

function* performUpdateCalendarEvent(action) {
  try {
    if (action.details) {
      var response = yield call(updateEvent, action.details);
      if (response.error === null) {
        yield put({ type: types.GRANT_UPDATE_CALENDAR_EVENT });
        yield put({
          type: types.CHANGE_CALENDAR_MODALS,
          modal: { editModal: false },
        });
      } else {
        throw new Error("Kunne ikke oppdatere hendelse.");
      }
    } else {
      throw new Error("Kunne ikke oppdatere hendelse.");
    }
  } catch (e) {
    yield put({ type: types.REVOKE_UPDATE_CALENDAR_EVENT, message: e });
    yield put({
      type: types.CHANGE_CALENDAR_MODALS,
      modal: { editModal: false },
    });
  }
}

function* calendarSaga() {
  yield all([
    takeEvery(types.REQUEST_CALENDAR_CONTENT, fetchCalendarDetails),
    takeEvery(types.REQUEST_ADD_CALENDAR_EVENT, performAddCalendarEvent),
    takeEvery(types.REQUEST_DELETE_CALENDAR_EVENT, performRemoveCalendarEvent),
    takeEvery(types.REQUEST_UPDATE_CALENDAR_EVENT, performUpdateCalendarEvent),
  ]);
}

export default calendarSaga;
